import TrackingResource from './resource';
import { Shipment } from '../index';

const REDIRECT_COMPANIES = ['CUS199515', 'CUS154114', 'CUS277455', 'CUS481125', 'CUS105827', 'CUS109145']; // [SendAFriend, Better Body EL, Proozy, Battle Beaver Customs, Compatible Inc(staging), mmmmm(qa1 - for testing purposes)]

async function find(keyword: string, recaptchaToken: string): Promise<Shipment | null> {
  return TrackingResource.find(encodeURIComponent(keyword), recaptchaToken).then((shipment) => {
    if (REDIRECT_COMPANIES.includes(shipment.easyship_company_id) && shipment.courier_tracking_url) {
      window.location.replace(shipment.courier_tracking_url);
    }
    return shipment;
  });
}

async function findPreview(companyId: string, recaptchaToken: string): Promise<Shipment> {
  return TrackingResource.findPreview(companyId, recaptchaToken);
}

async function shopify(action: 'track' | 'label', id: string, shop: string): Promise<Shipment> {
  const controller = action === 'label' ? 'label_info' : action;
  return TrackingResource.shopify(controller, id, shop);
}

const TrackingService = { find, findPreview, shopify };
export default TrackingService;
